import axios from "axios";
import { api } from "./api_route";

export const getCommAuditTrails = async () => {
  try {
    const response = await axios.get(`${api}/commAuditTrails/get`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
